import productionSitesQueries from '@/api/modules/productionSitesQueries'
import { PRODUCTION_SITES } from '@/constants'
import { useProductionSiteNotesService } from '@/views/Notes/services/productionSiteNotesService'

export function createNotesActions(state) {
    const productionSiteNotesService = useProductionSiteNotesService()

    /**
     * @param {string | { limit?: number | null | undefined, productionSiteId?: number | null | undefined, unreadById?: number | null | undefined } | undefined} [queryOrFilters]
     */
    const fetchProductionSiteNotes = async (queryOrFilters) => {
        try {
            state.productionSiteNotesLoading.value = true
            const response = await productionSiteNotesService.fetchProductionSiteNotes(queryOrFilters)
            state.productionSiteNotes.value = response.data.results || []
            return response
        } catch (error) {
            throw error
        } finally {
            state.productionSiteNotesLoading.value = false
        }
    }

    const fetchProductionSiteNote = async (id) => {
        try {
            state.productionSiteNotesLoading.value = true
            const response = await productionSiteNotesService.fetchProductionSiteNote(id)
            state.currentNote.value = response.data
            return response.data
        } catch (error) {
            throw error
        } finally {
            state.productionSiteNotesLoading.value = false
        }
    }

    const confirmProductionSiteNote = async (id) => {
        try {
            const response = await productionSiteNotesService.confirmProductionSiteNote(id)
            return response.data
        } catch (error) {
            throw error
        }
    }

    const fetchProductionSiteFormSites = async () => {
        const allowedTypeIds = [
            PRODUCTION_SITES.TYPES.CUTTING,
            PRODUCTION_SITES.TYPES.BINDING,
            PRODUCTION_SITES.TYPES.ORDERS,
            PRODUCTION_SITES.TYPES.SIGNATURES,
            PRODUCTION_SITES.TYPES.OFFSET_PRINTING
        ].join(',')
        const response = await productionSitesQueries.fetchProductionSitesBase({ type_id: allowedTypeIds })
        state.productionSiteFormSites.value = response.data.results || []
    }

    const createProductionSiteNote = async (data) => {
        try {
            state.productionSiteNotesLoading.value = true
            return await productionSiteNotesService.createProductionSiteNote(data)
        } catch (error) {
            throw error
        } finally {
            state.productionSiteNotesLoading.value = false
        }
    }

    const updateProductionSiteNote = async (data) => {
        try {
            state.productionSiteNotesLoading.value = true
            return await productionSiteNotesService.updateProductionSiteNote(data)
        } catch (error) {
            throw error
        } finally {
            state.productionSiteNotesLoading.value = false
        }
    }

    const deleteProductionSiteNote = async (id) => {
        try {
            state.productionSiteNotesLoading.value = true
            return await productionSiteNotesService.deleteProductionSiteNote(id)
        } catch (error) {
            throw error
        } finally {
            state.productionSiteNotesLoading.value = false
        }
    }

    const createProductionSiteNoteComment = async (data) => {
        try {
            return await productionSiteNotesService.createProductionSiteNoteComment(data)
        } catch (error) {
            throw error
        }
    }

    const fetchUnreadProductionSiteNotes = async (userId) => {
        try {
            const response = await productionSiteNotesService.fetchUnreadProductionSiteNotes(userId)
            const count = response.data?.count || 0
            state.unreadProductionSiteNotes.value = count
            return response
        } catch (error) {
            throw error
        }
    }

    const fetchUnreadProductionSiteNotesAmount = async (id) => {
        try {
            return await productionSiteNotesService.fetchUnreadProductionSiteNotesAmount(id)
        } catch (error) {
            throw error
        }
    }

    const setProductionSiteNotesFilters = (filters) => {
        state.filters.value = { ...state.filters.value, ...filters }
    }

    const clearProductionSiteNotesFilters = () => {
        state.filters.value = state.createInitialFilters()
    }

    const setUnreadProductionSiteNoteCount = (count) => {
        state.unreadProductionSiteNotes.value = count
    }

    return {
        fetchProductionSiteNotes,
        fetchProductionSiteNote,
        confirmProductionSiteNote,
        fetchProductionSiteFormSites,
        createProductionSiteNote,
        updateProductionSiteNote,
        deleteProductionSiteNote,
        createProductionSiteNoteComment,
        fetchUnreadProductionSiteNotes,
        fetchUnreadProductionSiteNotesAmount,
        setProductionSiteNotesFilters,
        clearProductionSiteNotesFilters,
        setUnreadProductionSiteNoteCount
    }
}
